import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SupportFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 3C15.5805 3 18.5332 5.68825 18.9497 9.15651C18.6326 9.15135 18.3169 9.22387 18.0337 9.36548L17.1056 9.82956C16.428 10.1683 16 10.8609 16 11.6184V16.3823C16 17.1399 16.428 17.8324 17.1056 18.1712L18.0337 18.6353C18.3145 18.7757 18.6272 18.8482 18.9416 18.8444C18.87 19.2799 18.743 19.4992 18.6211 19.6211C18.4374 19.8048 18.0325 20 17 20H15.7008C15.3219 19.1431 14.4679 18.5523 13.4629 18.5522H10.543C9.18039 18.5522 8.09473 19.6378 8.09473 21.0004C8.09494 22.3628 9.18053 23.4477 10.543 23.4477H13.4629C14.4681 23.4476 15.3221 22.8569 15.7009 22H17C18.1766 22 19.2711 21.7992 20.0352 21.0352C20.7992 20.2711 21 19.1766 21 18V17.6591C21.2745 17.3987 21.5596 17.1022 21.8241 16.7789C22.3964 16.0797 23 15.1026 23 14.0004C23 12.8982 22.3964 11.9211 21.8241 11.2218C21.5596 10.8986 21.2745 10.6021 21 10.3417V10C21 5.02944 16.9706 1 12 1C7.02944 1 3 5.02944 3 10V10.3417C2.72546 10.6021 2.44044 10.8986 2.17589 11.2218C1.60362 11.9211 1 12.8982 1 14.0004C1 15.1026 1.60362 16.0797 2.17589 16.7789C2.77042 17.5054 3.46838 18.0969 3.91826 18.4467C4.53058 18.9229 5.33022 18.9533 5.96627 18.6353L6.89443 18.1712C7.572 17.8324 8 17.1399 8 16.3823V11.6184C8 10.8609 7.572 10.1683 6.89443 9.82956L5.96627 9.36548C5.68306 9.22388 5.36741 9.15135 5.0503 9.15651C5.46685 5.68825 8.41949 3 12 3ZM13.4629 20.5278H11.1183H10.543C10.2729 20.5278 10.0703 20.7303 10.0703 21.0004C10.0705 21.2703 10.273 21.4721 10.543 21.4721H11.1182H13.4629C13.7327 21.4719 13.9344 21.2702 13.9346 21.0004C13.9346 20.7304 13.7328 20.5279 13.4629 20.5278Z"
				fill="currentColor"
			/>
		</svg>
	);
}

SupportFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SupportFilledIcon;
